export function adjustColor(hex: string, factor: number, opacity: number): string {
  // Remove the hash character if present
  hex = hex.replace(/^#/, "");

  // Parse the hex color to RGB
  const bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;

  // Adjust the color based on the factor
  r = Math.floor(r * factor);
  g = Math.floor(g * factor);
  b = Math.floor(b * factor);

  // Ensure the values are within the valid range (0-255)
  r = Math.min(255, Math.max(0, r));
  g = Math.min(255, Math.max(0, g));
  b = Math.min(255, Math.max(0, b));

  // Convert the adjusted RGB values to hex
  const adjustedHex = ((r << 16) | (g << 8) | b).toString(16).padStart(6, "0");

  // Convert the opacity to hex and ensure it's within the valid range (0-255)
  const adjustedOpacity = Math.min(255, Math.max(0, Math.floor(opacity * 255)))
    .toString(16)
    .padStart(2, "0");

  // Add the hash character and return the adjusted hex color with opacity
  return `#${adjustedHex}${adjustedOpacity}`;
}
